import { toast } from "sonner";

/**
 * useToast — thin wrapper around Sonner's imperative `toast()` API.
 *
 * Returned as a hook for parity with the shadcn-radix-toast contract
 * (where `useToast()` was needed to grab the dispatcher off context).
 * With Sonner the imperative dispatcher is a plain module function, so
 * this hook is allocation-free — it just returns the static `toast` object.
 *
 * @example
 *   const { toast: notify } = useToast();
 *   notify.success("Salvato");
 *   notify.error("Errore di rete", { description: e.message });
 */
export function useToast() {
  return { toast };
}

// NOTE: ``toast`` itself is re-exported from ``primitives/toast`` (the
// canonical path). Re-exporting it here too would surface the same symbol
// twice through ``packages/ui/src/index.ts`` (``export * from
// "./primitives"`` + ``export * from "./hooks"``) and esbuild rejects the
// resulting ambiguity with ``Ambiguous import "toast" has multiple
// matching exports`` on cold start (the warm HMR path tolerated it).
